import React, { useState, useEffect, useRef, useCallback } from "react"
import { toast } from "react-toastify"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import { CITYS, PRICES } from "../../utils/constants"

import "swiper/css"
import "swiper/css/navigation"
import {
    ClockChannel,
    WeathersChannels,
    SgInfoChannel,
    ServerName,
    PriceChannels,
    OnClientsChannel,
    OnAdminsChannel,
    JailChannel,
    NewClientsChannel,
    Connection,
    DateChannel,
    Permissions,
    BanClientsChannel,
    DynamicChannel,
    TempChannel,
    AutoRank,
    AutoCountry,
    AutoOs,
} from "./slides/Slides"
import { editManagerBot, fetchConnecitonData } from "../../services/managerBotApis"
import MyModal from "../MyModal"
import { getPermList } from "../../services/permissionsApis"
import { filterBotPermissions } from "../../utils/filterBotPermissions"
import actionHelper from "../../lib/actionHelper"
import StaffList from "./slides/StaffList"
import IdleTime from "./slides/IdleTime"
import DeathRoomChannel from "./slides/DeathRoomChannel"
import MultiRank from "./slides/MultiRank"
import MoveRequest from "./slides/MoveRequest"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"
import { useAuth } from "../../lib/useAuth"
import VoiceStatusChange from "./slides/VoiceStatusChange"
import ForbiddenMsgNotify from "./slides/ForbiddenMsgNotify"

const EditManagerBotModal = ({ bot }) => {
    const { user } = useAuth()
    const { isConnected, sendMessage } = useSocket()

    const [serverData, setServerData] = useState({})
    const [isOpen, setIsOpen] = useState(false)
    const [selectedPerms, setSelectedPerms] = useState(bot.permissions)
    const [permList, setPermList] = useState(null)
    const [indexSlide, setIndexSlide] = useState({})
    const swiperRef = useRef(null)

    const c = bot.channels

    const goToSlide = (slideIndex) => {
        if (slideIndex && swiperRef.current) {
            swiperRef.current.slideTo(slideIndex)
        }
    }
    const calculatePermissions = (permissions, selectedPerms) => {
        let amount = permissions.find((p) => p.name == "createBot").price
        for (let permName of Object.keys(selectedPerms)) {
            const { checked, multi } = selectedPerms[permName]
            if (checked) {
                const permission = permissions.find((p) => p.name == permName)
                if (multi) {
                    for (let i = 0; i < multi; i++) {
                        amount += permission.price
                    }
                }
            }
        }
        return amount
    }

    const slides = [
        {
            name: "dateChannels",
            element: (index = null) => (
                <DateChannel
                    index={index}
                    values={c.dateChannels ? c.dateChannels[index] : null}
                    serverData={serverData}
                />
            ),
        },
        {
            name: "clockChannels",
            element: (index = null) => (
                <ClockChannel
                    index={index}
                    values={c.clockChannels ? c.clockChannels[index] : null}
                    serverData={serverData}
                />
            ),
        },
        {
            name: "onClientsChannel",
            element: (index = null) => (
                <OnClientsChannel index={index} values={c.onClientsChannel} serverData={serverData} />
            ),
        },
        {
            name: "onAdminsChannel",
            element: (index = null) => (
                <OnAdminsChannel index={index} values={c.onAdminsChannel} serverData={serverData} />
            ),
        },
        {
            name: "priceChannels",
            element: (index = null) => <PriceChannels index={index} values={c.priceChannels} serverData={serverData} />,
        },
        {
            name: "jailChannels",
            element: (index = null) => (
                <JailChannel
                    index={index}
                    values={c.jailChannels ? c.jailChannels[index] : null}
                    serverData={serverData}
                />
            ),
        },
        {
            name: "newClientsChannel",
            element: (index = null) => (
                <NewClientsChannel index={index} values={c.newClientsChannel} serverData={serverData} />
            ),
        },
        {
            name: "banClientsChannel",
            element: (index = null) => (
                <BanClientsChannel index={index} values={c.banClientsChannel} serverData={serverData} />
            ),
        },
        {
            name: "weathersChannels",
            element: (index = null) => (
                <WeathersChannels index={index} values={c.weathersChannels} serverData={serverData} />
            ),
        },
        {
            name: "sgInfoChannels",
            element: (index = null) => (
                <SgInfoChannel
                    index={index}
                    values={c.sgInfoChannels ? c.sgInfoChannels[index] : null}
                    serverData={serverData}
                />
            ),
        },
        {
            name: "serverName",
            element: (index = null) => <ServerName index={index} values={c.serverName} serverData={serverData} />,
        },
        {
            name: "dynamicChannels",
            element: (index = null) => (
                <DynamicChannel
                    index={index}
                    values={c.dynamicChannels ? c.dynamicChannels[index] : null}
                    serverData={serverData}
                />
            ),
        },
        {
            name: "tempChannel",
            element: (index = null) => <TempChannel index={index} values={c.tempChannel} serverData={serverData} />,
        },
        {
            name: "autoRank",
            element: (index = null) => <AutoRank index={index} values={c.autoRank} serverData={serverData} />,
        },
        {
            name: "autoCountry",
            element: (index = null) => <AutoCountry index={index} values={c.autoCountry} serverData={serverData} />,
        },
        {
            name: "autoOs",
            element: (index = null) => <AutoOs index={index} values={c.autoOs} serverData={serverData} />,
        },
        {
            name: "staffList",
            element: (index = null) => (
                <StaffList index={index} values={c.staffList ? c.staffList[index] : null} serverData={serverData} />
            ),
        },
        {
            name: "idleTime",
            element: (index = null) => <IdleTime index={index} values={c.idleTime} serverData={serverData} />,
        },
        {
            name: "deathRoomChannel",
            element: (index = null) => (
                <DeathRoomChannel index={index} values={c.deathRoomChannel} serverData={serverData} />
            ),
        },
        {
            name: "multiRank",
            element: (index = null) => <MultiRank index={index} values={c.multiRank} serverData={serverData} />,
        },
        {
            name: "moveRequest",
            element: (index = null) => <MoveRequest index={index} values={c.moveRequest} serverData={serverData} />,
        },
        {
            name: "forbiddenMsgNotify",
            element: (index = null) => (
                <ForbiddenMsgNotify index={index} values={c.forbiddenMsgNotify} serverData={serverData} />
            ),
        },
        {
            name: "voiceStatusChange",
            element: (index = null) => (
                <VoiceStatusChange index={index} values={c.voiceStatusChange} serverData={serverData} />
            ),
        },
    ]

    const permsInputs = {
        clockChannels: {
            isMulti: true,
            inputs: ["id", "format"],
        },
        dateChannels: {
            isMulti: true,
            inputs: ["id", "format"],
        },
        onClientsChannel: {
            isMulti: false,
            inputs: ["id", "format", "ignoreSgList"],
        },
        onAdminsChannel: {
            isMulti: false,
            inputs: ["id", "format", "adminSgList"],
        },
        priceChannels: {
            isMulti: false,
            inputs: (() => {
                let obj = {}
                PRICES.forEach((curr) => {
                    obj[curr.en] = ["id", "format"]
                })

                return obj
            })(),
        },
        jailChannels: {
            isMulti: true,
            inputs: ["id", "sgId", "time", "format"],
        },
        newClientsChannel: {
            isMulti: false,
            inputs: ["id", "clientDesc", "format", "descFormat"],
        },
        banClientsChannel: {
            isMulti: false,
            inputs: ["id", "nameFormat", "descriptionFormat"],
        },
        weathersChannels: {
            isMulti: false,
            inputs: (() => {
                let obj = {}
                CITYS.forEach((city) => {
                    obj[city.en] = ["id", "format"]
                })

                return obj
            })(),
        },
        sgInfoChannels: {
            isMulti: true,
            inputs: ["id", "sgId", "nameFormat", "descriptionFormat"],
        },
        serverName: {
            isMulti: false,
            inputs: ["format"],
        },
        dynamicChannels: {
            isMulti: true,
            inputs: ["id", "minChannels", "format", "maxChannels", "maxClients", "joinPower", "iconId"],
        },
        tempChannel: {
            isMulti: false,
            inputs: ["listenId", "parentId", "cgId", "nameFormat", "pokeFormat", "iconId"],
        },
        autoRank: {
            isMulti: false,
            inputs: ["canUseIds", "maxMsg", "ranks", "msgFormat"],
        },
        autoCountry: {
            isMulti: false,
            inputs: ["ignoreSgList", "countryList"],
        },
        autoOs: {
            isMulti: false,
            inputs: ["ignoreSgList", "mac", "windows", "android", "linux", "iOS"],
        },
        staffList: {
            isMulti: true,
            inputs: ["id", "clickable", "staffSgList", "descFormat", "usersFormat"],
        },
        idleTime: {
            isMulti: false,
            inputs: ["ignoreSgList", "timeList"],
        },
        deathRoomChannel: {
            isMulti: false,
            inputs: ["id", "ignoreSgList", "msg", "kickMsg"],
        },
        multiRank: {
            isMulti: false,
            inputs: ["rankId", "multiRanks"],
        },
        moveRequest: {
            isMulti: false,
            inputs: ["canUseList", "joinMsg", "moveMsg"],
        },
        forbiddenMsgNotify: {
            isMulti: false,
            inputs: ["sgListToNotify", "ignoreSgList", "forbiddenWords", "pokeFormat"],
        },
        voiceStatusChange: {
            isMulti: false,
            inputs: ["sgListToNotify", "ignoreSgList", "adminPokeFormats", "clientPokeFormats"],
        },
    }

    const handlePermList = useCallback((permList) => {
        setPermList(permList)
    }, [])

    useSocketEvent("permList", handlePermList)

    useEffect(() => {
        if (isOpen && isConnected) {
            sendMessage("getPermList")
            fetchConnecitonData({
                host: bot.conn.host,
                serverPort: bot.conn.serverPort,
                queryPort: bot.conn.queryPort,
                password: bot.conn.queryPassword,
                username: bot.conn.username,
            })
                .then((res) => {
                    toast.success("اطلاعات سرور دریافت شد")
                    setServerData(res.data)
                })
                .catch(() => {})
            setSelectedPerms(bot.permissions)
        }
    }, [isOpen, isConnected])

    useEffect(() => {
        let slideIndex = 2
        let obj = {}
        for (let key of Object.keys(selectedPerms)) {
            const perm = selectedPerms[key]
            if (!perm.checked) continue
            obj[key] = slideIndex
            slideIndex += perm.multi ? parseInt(perm.multi) : 1
        }
        setIndexSlide(obj)
    }, [selectedPerms])

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const editBotFormSubmitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)
        let data = {}
        data.botId = bot.id
        data.panelId = form.get("panel-id")
        data.selectedPerms = { ...selectedPerms }
        data.conn = {
            host: form.get("connection-host"),
            serverPort: form.get("connection-serverport"),
            queryPort: form.get("connection-queryport"),
            queryPassword: form.get("connection-querypassword"),
            username: form.get("connection-username"),
            botName: form.get("connection-botname"),
        }
        data.channels = {}
        for (let key of Object.keys(selectedPerms)) {
            if (!selectedPerms[key].checked) {
                continue
            }
            const { isMulti, inputs } = permsInputs[key]

            if (!isMulti) {
                data.channels[key] = {}
                if (Array.isArray(inputs)) {
                    for (let input of inputs) {
                        data.channels[key][input] = form.get(`${key}-${input}`)
                    }
                } else {
                    for (let j of Object.keys(inputs)) {
                        data.channels[key][j] = {}
                        for (let c of inputs[j]) {
                            data.channels[key][j][c] = form.get(`${key}-${j}-${c}`)
                        }
                    }
                }
            } else if (isMulti) {
                data.channels[key] = []
                const multiCount = selectedPerms[key].multi
                for (let i = 0; i < multiCount; i++) {
                    let obj = {}
                    for (let input of inputs) {
                        obj[input] = form.get(`${key}-${i}-${input}`)
                    }
                    data.channels[key].push(obj)
                }
            }
        }
        var { price } = filterBotPermissions(bot, selectedPerms, bot.permissions, permList)

        console.log(data)

        actionHelper({
            confirmation: {
                label: `مقدار ${price} از حساب شما کم میشود آیا مایل به ویرایش هستید؟ و اگر تیک هرکدوم از قابلیت هارا وردارید مبلغی به حساب شما اضافه نمیشود`,
                actionLabel: "ویرایش",
                color: "warning",
            },
            callback: () => editManagerBot(data),
            texts: { success: "ویرایش شد", pending: "درحال ویرایش بات مدیریتی" },
        })
    }

    const handlePermissionsOnChange = (permName) => {
        const isChecked = document.getElementById(permName).checked
        const multi = document.getElementById(`${permName}-multi`)?.value

        setSelectedPerms((selectedPerms) => {
            let newObject = { ...selectedPerms }
            newObject[permName] = {}
            newObject[permName]["checked"] = isChecked
            if (multi) {
                newObject[permName]["multi"] = multi
            }
            return newObject
        })
    }

    return (
        <>
            <button
                onClick={toggleModal}
                style={{ backgroundColor: "#3A4B5C" }}
                className="flex justify-center border bg-slate-500 text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-slate-600 focus:outline-none focus:shadow-outline"
            >
                <svg
                    fill="none"
                    height="30"
                    viewBox="0 0 24 24"
                    width="30"
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-2 text-xs"
                >
                    <path
                        d="M21.0312 2.96948C22.4286 4.36695 22.4286 6.63268 21.0312 8.03014L18.0393 11.022C17.8618 11.0074 17.6823 11 17.501 11C16.8694 11 16.2588 11.0901 15.6814 11.2581L17.94 8.99939L15.001 6.06039L5.06283 15.9985C4.97054 16.0908 4.90393 16.2055 4.86959 16.3315L3.81974 20.1809L7.66918 19.1311C7.7951 19.0967 7.90988 19.0301 8.00217 18.9378L11.259 15.6808C11.091 16.2581 11.001 16.8685 11.001 17.5C11.001 17.6813 11.0084 17.8608 11.023 18.0384L9.06283 19.9985C8.78596 20.2753 8.44162 20.4752 8.06386 20.5782L2.94817 21.9734C2.38829 22.1261 1.87456 21.6123 2.02726 21.0525L3.42244 15.9368C3.52547 15.559 3.7253 15.2147 4.00217 14.9378L15.9705 2.96948C17.368 1.57202 19.6337 1.57202 21.0312 2.96948ZM17.0312 4.03014L16.061 4.99939L19 7.93939L19.9705 6.96948C20.7822 6.15781 20.7822 4.84182 19.9705 4.03014C19.1588 3.21847 17.8428 3.21847 17.0312 4.03014ZM14.2792 13.9754C14.5939 15.0656 13.9396 16.1991 12.838 16.4716L12.2538 16.6161C12.2089 16.9038 12.1855 17.199 12.1855 17.4998C12.1855 17.8145 12.2111 18.123 12.2601 18.4232L12.7996 18.5532C13.9121 18.8211 14.5734 19.9661 14.2496 21.0636L14.0633 21.6949C14.5024 22.0805 15.0029 22.3937 15.5474 22.6165L16.0407 22.0977C16.8293 21.2685 18.1515 21.2687 18.9398 22.0982L19.4385 22.623C19.9821 22.4027 20.4821 22.0925 20.9213 21.7101L20.7233 21.0242C20.4085 19.9339 21.0629 18.8005 22.1645 18.528L22.7482 18.3835C22.7931 18.0958 22.8165 17.8006 22.8165 17.4998C22.8165 17.1851 22.7909 16.8765 22.7418 16.5762L22.2029 16.4464C21.0904 16.1785 20.4291 15.0335 20.7529 13.9359L20.9391 13.3051C20.4999 12.9193 19.9995 12.6061 19.4549 12.3833L18.9618 12.9018C18.1732 13.7311 16.8509 13.7309 16.0627 12.9013L15.5639 12.3765C15.0203 12.5967 14.5204 12.9068 14.0811 13.2892L14.2792 13.9754ZM17.501 18.9998C16.7004 18.9998 16.0513 18.3282 16.0513 17.4998C16.0513 16.6714 16.7004 15.9998 17.501 15.9998C18.3016 15.9998 18.9507 16.6714 18.9507 17.4998C18.9507 18.3282 18.3016 18.9998 17.501 18.9998Z"
                        fill="#f4f4f5"
                    />
                </svg>
                ویرایش بات
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} height="500px" width="900px">
                <div className="flex-col  h-full">
                    <form className="h-full" onSubmit={editBotFormSubmitHandler}>
                        <Swiper
                            modules={[Navigation]}
                            onSwiper={(swiper) => (swiperRef.current = swiper)} // Capture Swiper instance
                            slidesPerView={1}
                            className="h-[85%] y-scroll"
                            simulateTouch={false}
                            navigation
                        >
                            <SwiperSlide>
                                <Permissions
                                    user={user}
                                    handlePermissionsOnChange={handlePermissionsOnChange}
                                    goToSlide={goToSlide}
                                    indexSlide={indexSlide}
                                    permList={permList}
                                    selectedPerms={bot.permissions}
                                    templateName={bot.template_name}
                                    botPanelId={bot.panel_id}
                                />
                            </SwiperSlide>
                            <SwiperSlide>
                                <Connection user={user} values={bot.conn} setServerData={setServerData} />
                            </SwiperSlide>
                            {Object.keys(selectedPerms).map((key, index) => {
                                const el = slides.find((s) => s.name === key).element
                                if (selectedPerms[key].checked && selectedPerms[key].multi) {
                                    const multi = selectedPerms[key].multi
                                    let elements = []
                                    for (let i = 0; i < multi; i++) {
                                        elements.push(
                                            <SwiperSlide className="h-full y-scroll" key={index + i}>
                                                {el(i)}
                                            </SwiperSlide>,
                                        )
                                    }
                                    return <div>{elements}</div>
                                } else if (selectedPerms[key].checked) {
                                    return (
                                        <SwiperSlide className="h-full y-scroll" key={index}>
                                            {el()}
                                        </SwiperSlide>
                                    )
                                }
                            })}
                        </Swiper>

                        <button type="submit" class="styled-button mt-5 ml-2 w-full">
                            ویرایش بات
                        </button>
                    </form>
                </div>
            </MyModal>
        </>
    )
}

export default EditManagerBotModal
